module.exports = __webpack_public_path__ + "static/media/msgIn.a7e019fd.ogg";